import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import {
  CreateSpecializationRequest,
  UpdateSpecializationRequest,
  SpecializationsResponse,
  SpecializationResponse,
} from './types/specialization.types';

export const specializationService = {
  /**
   * Get all specializations
   */
  async getSpecializations(): Promise<SpecializationsResponse> {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN.SPECIALIZATIONS);
    return response.data;
  },

  /**
   * Get specialization by ID
   */
  async getSpecialization(id: number): Promise<SpecializationResponse> {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN.SPECIALIZATION_DETAIL(id));
    return response.data;
  },

  /**
   * Create a new specialization
   */
  async createSpecialization(data: CreateSpecializationRequest): Promise<SpecializationResponse> {
    const response = await apiClient.post(API_ENDPOINTS.ADMIN.SPECIALIZATIONS, data);
    return response.data;
  },

  /**
   * Update an existing specialization
   */
  async updateSpecialization(id: number, data: UpdateSpecializationRequest): Promise<SpecializationResponse> {
    const response = await apiClient.put(API_ENDPOINTS.ADMIN.SPECIALIZATION_DETAIL(id), data);
    return response.data;
  },

  /**
   * Delete a specialization
   */
  async deleteSpecialization(id: number): Promise<{ message: string }> {
    const response = await apiClient.delete(API_ENDPOINTS.ADMIN.SPECIALIZATION_DETAIL(id));
    return response.data;
  },
};
